<template>
  <card-info-component
    :title="$t('pages.dashboard.widgets.vacation_days')"
    :value="holidaysRemaining"
    :is-loading="!userData"
    icon="fa-umbrella-beach"
    tone="success"
  ></card-info-component>
</template>

<script>
import { CardInfoComponent } from "@/pages/components";
import { mapGetters } from "vuex";

export default {
  components: {
    CardInfoComponent,
  },
  computed: {
    ...mapGetters("auth", ["holidaysRemaining", "userData"]),
  },
};
</script>

<style scoped></style>
